module.exports = __webpack_public_path__ + "spine/cow.json?3cb6a8f37e1633451005918fbb993d9a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/cow/cow.json
// module id = 1739
// module chunks = 3